module.exports = __webpack_public_path__ + "installed-source-hero-8cc2ac6e746a3ed68ab1d0118ebd9805.png";